import { render } from "./Map.vue?vue&type=template&id=e5d56586"
import script from "./Map.vue?vue&type=script&lang=js"
export * from "./Map.vue?vue&type=script&lang=js"
script.render = render

export default script